<template>
  <b-container class="col-12 custPdfContainer">
      <section class="pdf-item" v-if="searchtype !== 1">
        <div class="col-12" style="font-weight: normal !important; font-size: 12px !important">
            <span>
              <i class="fa fa-wheelchair"></i> Handicap Accessible |
              <i class="fa fa-medal"></i> Board Certified |
              <i class="fa fa-font"></i> Accepting New Patient
            </span>
        </div>
        <hr/>
        <div class="col-12 break-avoid" v-for="(spec, sIndex) in specialties" :key="sIndex">
          <h3>{{ spec }}</h3>
          <div v-for="(st, stIndex) in states" :key="stIndex" class="ml-4">
            <div v-if="st.specialty===spec">
              <h4>{{ getStateName(st.state) }}</h4>
              <div v-for="(county, cIndex) in counties" :key="cIndex" class="ml-4">
                <div v-if="county.state===st.state && county.specialty === spec">
                  <h5>{{ county.county }}</h5>
                  <div v-for="(prov, pIndex) in providers" :key="pIndex" class="ml-4">
                    <div v-if="prov.County === county.county && prov.State === st.state && prov.PrimarySpecialtyName == spec" >

                      <span v-if="prov.ProviderKey !== 0 && prov.IsBoardCertified === 1">
                            <i class="fa fa-medal"></i>
                      </span>
                      <span class="customLabel" :class="(prov.IsBoardCertified === 1)?'ml-1':'ml-4'">{{ prov.ProviderFirstName }} {{ prov.ProviderLastName }}</span>
                      <span class="customLabel" v-if="prov.PrimaryDegreeName">, {{ prov.PrimaryDegreeName }}</span>
                      <br/>
                      <span v-if="prov.WheelChairAccess === 1">
                            <i class="fa fa-wheelchair"></i>
                      </span>
                      <span class="customLabel" :class="(prov.WheelChairAccess === 1)?'ml-1':'ml-4'">
                            {{ prov.Street1 }}{{
                          prov.Street2 ? ', ' + prov.Street2 : ''
                        }}
                      </span>
                      <br/>
                      <span class="ml-4 customLabel">
                        {{ prov.City }}{{ prov.State ? ', ' + prov.State : '' }}&nbsp;{{
                          prov.Zip?', '+prov.Zip:''
                        }}{{ prov.distance ? ', ' + prov.distance : '' }}
                      </span>
                      <br/>
                      <span class="ml-4 customLabel" v-if="prov.Phone">Phone: {{prov.Phone | VMask('(###)-###-####') }}</span>
                      <br v-if="prov.Phone"/>
                      <span class="ml-4 customLabel">Accepting New Patient: {{prov.AcceptingNewMember === 1?'Yes':'No'}}</span>
                      <br/> <br/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br/>
        </div>
      </section>
      <section class="pdf-item" v-if="searchtype === 1">
        <div class="col-12" style="font-weight: normal !important; font-size: 12px !important">
            <span>
              <i class="fa fa-wheelchair"></i> Handicap Accessible
            </span>
        </div>
        <hr/>
          <div v-for="(st, stIndex) in states" :key="stIndex" class="ml-4 break-avoid">
              <h4>{{ getStateName(st.state) }}</h4>
              <div v-for="(county, cIndex) in counties" :key="cIndex" class="ml-4">
                <div v-if="county.state===st.state">
                  <h5>{{ county.county }}</h5>
                  <div v-for="(prov, pIndex) in providers" :key="pIndex" class="ml-4">
                    <div v-if="prov.County === county.county">
                      <span v-if="prov.WheelChairAccess === 1">
                            <i class="fa fa-wheelchair"></i>
                      </span>
                      <span class="customLabel" :class="(prov.WheelChairAccess === 1)?'ml-1':'ml-4'">{{ prov.HospitalName }}</span>
                      <br/>
                      <span class="customLabel ml-4">
                            {{ prov.Street1 }}{{
                          prov.Street2 ? ', ' + prov.Street2 : ''
                        }}
                      </span>
                      <br/>
                      <span class="ml-4 customLabel">
                        {{ prov.City }}{{ prov.State ? ', ' + prov.State : '' }}&nbsp;{{
                          prov.Zip?', '+prov.Zip:''
                        }}{{ prov.distance ? ', ' + prov.distance : '' }}
                      </span>
                      <br/>
                      <span class="ml-4 customLabel" v-if="prov.Phone">Phone: {{prov.Phone | VMask('(###)-###-####') }}</span>
<!--                      <br v-if="prov.Phone"/>-->
<!--                      <span class="ml-4 customLabel">Accepting New Patient: {{prov.AcceptingNewMember === 1?'Yes':'No'}}</span>-->
                      <br/> <br/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          <br/>
      </section>
  </b-container>
</template>
<script>

export default {
  name: "ProviderPdfComponent",
  components: {},
  data() {
    return {
      logoUrl: '',
      specialties: [],
      states: [],
      counties: [],
    };
  },
  props: {
    providers: Array,
    statenames: Array,
    searchtype: Number
  },
  async created() {
    if (this.providers.length > 0) {
      this.providers.sort((a, b) => (a.ProviderFirstName+a.ProviderLastName).localeCompare(b.ProviderFirstName+b.ProviderLastName) )
      for (let item of this.providers) {
        if (this.searchtype !== 1 && this.specialties.indexOf(item.PrimarySpecialtyName) === -1) {
          this.specialties.push(item.PrimarySpecialtyName);
        }
        let stateItemExists = false;
        let stateItem ={}
        if (this.searchtype !== 1) {
          stateItem = {state: item.State, specialty: item.PrimarySpecialtyName}
          for (let i = 0; i < this.states.length; i++) {
            if (this.states[i].state == stateItem.state && this.states[i].specialty == stateItem.specialty) {
              stateItemExists = true;
            }
          }
        }else{
          stateItem = {state: item.State}
          for (let i = 0; i < this.states.length; i++) {
            if (this.states[i].state == stateItem.state) {
              stateItemExists = true;
            }
          }
        }
        if (!stateItemExists && item.State) {
          this.states.push(stateItem);
        }
        let countyItemExists = false;
        let countyItem = {};
        if (this.searchtype !== 1) {
          countyItem = {state: item.State, county: item.County, specialty: item.PrimarySpecialtyName};
          for (let i = 0; i < this.counties.length; i++) {
            if (this.counties[i].state == countyItem.state && this.counties[i].county == countyItem.county && this.counties[i].specialty == countyItem.specialty) {
              countyItemExists = true;
            }
          }
        }else{
          countyItem = {state: item.State, county: item.County};
          for (let i = 0; i < this.counties.length; i++) {
            if (this.counties[i].state == countyItem.state && this.counties[i].county == countyItem.county) {
              countyItemExists = true;
            }
          }
        }
        if (!countyItemExists && item.County) {
          this.counties.push(countyItem);
        }
      }
      if (this.searchtype !== 1){
        this.specialties.sort((a, b) => a.localeCompare(b));
      }
      this.states.sort((a, b) => a.state.localeCompare(b.state));
      this.counties.sort((a, b) => a.county.localeCompare(b.county));
    }
    if (process.env.VUE_APP_CLIENT) {
      this.logoUrl = window.location.origin + '/images/logos/' + process.env.VUE_APP_CLIENT + '.png';
    } else {
      this.logoUrl = window.location.origin + '/images/logos/logo.png';
    }
  },
  methods: {
    getStateName(st) {
      var selLang = this.statenames.filter(function (item) {
        return item.State === st;
      });
      return selLang[0].StateName;
    }
  }

};
</script>
<style scoped>

.break-before {
  page-break-before: always;
}

.break-after {
  page-break-after: always;
}

.break-avoid {
  page-break-inside: avoid;
}

.fullpage {
  max-height: 792pt;
}
.customLabel {
  font-weight: normal !important;
  font-size: 18px !important;
  color: black;
}


.imgLogo {
  float: left;
  height: 100px;
  margin-right: 10px;
}


.provrow:hover {
  background-color: #f1f6f6;
}

.card-body {
  padding: 0.55rem !important;
}

.anchor {
  border: 1px solid transparent;
  font-size: 14px;
  padding: 0.75rem 0.5rem;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
  border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  color: #fff;
  background-color: #25a7ce;
  border-color: #25a7ce;
}

.arrowDownIcon::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.5em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.28em solid transparent;
  border-bottom: 0;
  border-left: 0.28em solid transparent;
}

.anchor:hover {
  color: #fff;
  background-color: #248cab;
  border-color: #268cab;
  cursor: pointer;
}

.menu {
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  color: #212529;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  list-style: none;
  margin: 0.125rem 0 0;
  padding: 0.5rem 0.5rem;
  position: absolute;
  text-align: left;
  width: 94%;
  z-index: 1;
  margin-top: 0px !important;
}

.btn-info.disabled, .btn-info:disabled {
  cursor: default;
}

.btn-secondary.disabled, .btn-secondary:disabled {
  cursor: default;
}

span {
  font-weight: bold;
  color: #717573;
  /*font-size: 14px;*/
}

.textDesc {
  font-weight: normal;
  color: #2c3e50;
}

.selTags {
  color: #717573;
  background-color: #fff;
  border: #fff;
  border-right: 1px solid #717573;
  padding-right: 3px !important;
  border-radius: 0;
}

.closeTags {
  font-size: 14px;
}

.filterText {
  color: #25a7ce;
}

sub,
sup {
  font-size: 14px;
  margin-right: 2px;
}

sup:hover {
  color: red !important;
}

.zipBoxSm {
  display: none;
}

.customLabel {
  font-size: 14px;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

::-webkit-input-placeholder {
  color: #dde2e7;
  font-size: var(--font-size);
}

::-moz-placeholder {
  color: #dde2e7;
  font-size: 13px;
}

:-ms-input-placeholder {
  color: #dde2e7;
  font-size: 13px;
}

::placeholder {
  color: #dde2e7;
  font-size: 13px;
}

.selectCust1 {
  background: #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.05rem center/8px 10px !important;
  width: 60px !important;
  padding-left: 10px !important;
}

.spinner {
  text-align: -webkit-center;
}

.hourBox {
  text-align: right;
  min-width: 25pt;
}

.customTitle {
  color: #5A5C5E;
  font-weight: 600;
  font-size: 20pt;
  margin: 0;
  border-left: 2px solid #ccc;
  padding-left: 10px;
}

.imgLogo {
  float: left;
  height: 60px;
}

.zipCodeInput {
  width: 145px !important;
  float: left;
}

.zipMilesSelect {
  width: 100px !important;
  float: left;
}

.card {
  border-radius: 20px !important;
}

@media screen and (min-width: 1000px) {
  .custPadding {
    padding: 0px !important;
  }
}

@media screen and (min-width: 1600px) {
  .custPadding {
    padding: 0px !important;
  }
}

@media screen and (min-width: 1900px) {
  .custPadding {
    padding-right: 15px !important;
    padding-left: 15px !important;
  }
}

@media screen and (max-width: 1300px) {
  .custFontHeader {
    font-size: 20px !important;
    margin-bottom: 5px;
  }

  .card-body {
    font-size: 12px;
  }

  span {
    font-size: 12px;
  }
}

@media screen and (max-width: 1024px) {
  .custom-checkbox {
    display: inline-block;
    margin-left: 5px;
  }

  .hiddenSm {
    display: none
  }

  .hourBox {
    /*padding:0px 2px 0px 0px !important;*/
  }

}

@media screen and (max-width: 908px) {
  .zipMilesSelect {
    margin-left: 0px !important;
    margin-top: 5px !important;
    clear: both;
  }

  .zipBoxSm {
    display: block;
  }

}

@media screen and (max-width: 767px) {
  .hiddenXs {
    display: none;
  }

  .hourBox {
    text-align: left;
    /*margin-left: 15px !important;*/
    padding-left: 20px !important;
  }
}

@media screen and (max-width: 575px) {
  .zipMilesSelect {
    width: 40% !important;
    margin-top: 0px !important;
    margin-left: 15px !important;
    clear: none;
  }

  .zipCodeInput {
    width: 45% !important;
  }

  .hourBox {
    text-align: left;
    /*margin-left: 15px !important;*/
    padding-left: 20px !important;
  }
}

/*@media only screen and (max-width: 768px) and (min-width: 520px)  {*/
/*  .hourBox{*/
/*    padding:0px 5px 0px 0px !important;*/
/*    padding-left: 15px !important;*/
/*  }*/
/*}*/
@media screen and (max-width: 520px) {
  .inner-box-right {
    border-right: none !important;
  }

  .hiddenXs {
    display: none;
  }

  .hourBox {
    text-align: left;
  }

  .imgLogo {
    float: none !important;
  }

  .selTags {
    border-right: 0px !important;
  }

  .tagBox {
    padding: 0px !important;
  }

  .customTitle {
    border: none !important;
  }

  .titleBx {
    float: none !important;
    padding-top: 10px !important;
  }

  .selectCust1 {
    width: 40px !important;
    padding-left: 6px !important;
    padding-right: 1px !important;
  }
}
</style>
